import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchPortalUsers } from "../../../../utils/redux/portalUser/portalUserActions";

const PortalUserListingPage = () => {

    const dispatch = useDispatch();

    const {
        portalUsers,
        pagination,
        isLoading
    } = useSelector(state => state.portalUser);

    const [filters, setFilters] = useState({
        role: "",
        page: 1,
        limit: 20
    });

    useEffect(() => {

        dispatch(fetchPortalUsers(filters));

    }, [filters]);

    const handleRefersh = () => {
        dispatch(fetchPortalUsers(filters));
    }

    return (

        <div className="container">

            <div className="d-flex justify-content-between align-items-center my-4">

                <h3>Portal Users</h3>
                <button onClick={handleRefersh} className="button button-primary">
                    Refresh
                </button>

            </div>

            {/* FILTERS */}

            <div className="row mb-4">

                <div className="col-md-3">

                    <select
                        className="form-select"
                        onChange={(e) =>
                            setFilters(prev => ({
                                ...prev,
                                role: e.target.value
                            }))
                        }
                    >

                        <option value="">All Roles</option>
                        <option value="USER">USER</option>
                        <option value="TEAM">TEAM</option>
                        <option value="AID">AID</option>

                    </select>

                </div>

            </div>

            <table className="table table-bordered table-hover align-middle">

                <thead className="table-secondary">

                    <tr>

                        <th>Name</th>
                        <th>Email</th>
                        <th>Phone</th>
                        <th>Role</th>
                        <th>Status</th>
                        <th>Logged In</th>
                        <th>Last Login</th>
                        <th>Last Active</th>
                        <th>Created</th>

                    </tr>

                </thead>

                <tbody>

                    {isLoading ? (

                        <tr>

                            <td
                                colSpan="9"
                                className="text-center"
                            >
                                Loading...
                            </td>

                        </tr>

                    ) : portalUsers.length ? (

                        portalUsers.map(user => (

                            <tr key={user._id}>

                                <td>
                                    {user.first_name} {user.last_name}
                                </td>

                                <td>{user.email}</td>

                                <td>{user.phone || "-"}</td>

                                <td>

                                    <span className="badge bg-primary">
                                        {user.role}
                                    </span>

                                </td>

                                <td>

                                    {user.status ? (

                                        <span className="badge bg-success">
                                            Active
                                        </span>

                                    ) : (

                                        <span className="badge bg-danger">
                                            Inactive
                                        </span>

                                    )}

                                </td>

                                <td>

                                    {user.hasLoggedIn ? (

                                        <span className="badge bg-success">
                                            Yes
                                        </span>

                                    ) : (

                                        <span className="badge bg-warning text-dark">
                                            No
                                        </span>

                                    )}

                                </td>

                                <td>

                                    {
                                        user.lastLoginAt
                                            ? new Date(user.lastLoginAt).toLocaleString()
                                            : "-"
                                    }

                                </td>

                                <td>

                                    {
                                        user.lastActiveAt
                                            ? new Date(user.lastActiveAt).toLocaleString()
                                            : "-"
                                    }

                                </td>

                                <td>

                                    {
                                        new Date(user.createdAt).toLocaleDateString()
                                    }

                                </td>

                            </tr>

                        ))

                    ) : (

                        <tr>

                            <td
                                colSpan="9"
                                className="text-center text-muted"
                            >
                                No Portal Users Found
                            </td>

                        </tr>

                    )}

                </tbody>

            </table>

            {pagination.total > 0 && (

                <div className="d-flex justify-content-between align-items-center mt-4">

                    <div>
                        <strong>Total Users:</strong> {pagination.total}
                    </div>

                    <div className="d-flex align-items-center gap-2">

                        <button
                            className="btn btn-outline-secondary btn-sm"
                            disabled={!pagination.hasPreviousPage}
                            onClick={() =>
                                setFilters(prev => ({
                                    ...prev,
                                    page: prev.page - 1
                                }))
                            }
                        >
                            Previous
                        </button>

                        <span>
                            Page <strong>{pagination.page}</strong> of{" "}
                            <strong>{pagination.totalPages}</strong>
                        </span>

                        <button
                            className="btn btn-outline-secondary btn-sm"
                            disabled={!pagination.hasNextPage}
                            onClick={() =>
                                setFilters(prev => ({
                                    ...prev,
                                    page: prev.page + 1
                                }))
                            }
                        >
                            Next
                        </button>

                    </div>

                </div>

            )}

        </div>

    );

};

export default PortalUserListingPage;